import { Input } from "@/src/components/universalInput";
import { Appointment, refusalCategories } from "@/src/data/allTypes";

export default function AppointmentRefusalForm({
  current,
  onChange,
}: {
  current: Appointment;
  onChange: (newValue: Appointment) => void;
}) {
  return (
    <div className="c1 gap10">
      <Input
        name="Motif"
        type="select"
        value={current.refusalCategory}
        options={Object.values(refusalCategories)
          .filter((category) => category.type != "anapath")
          .map((category) => {
            return {
              value: category.id,
              label: category.name,
            };
          })}
        onChange={(newValue) => {
          current.refusalCategory = newValue;
          onChange(current);
        }}
      ></Input>
      <Input
        name="Détails"
        type="textarea"
        value={current.refusalNotes || "Cher confrère, \n"}
        rows={6}
        onChange={(newValue) => {
          current.refusalNotes = newValue;
          onChange(current);
        }}
      />
    </div>
  );
}
